import AskSmartPreplan from './AskSmartPreplan';
import { Drawer } from './ui/Drawer';
import { useAltHotkeys } from '../hooks/useAltHotkeys';

export default function AskSmartPreplanDrawer({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  useAltHotkeys({ C: onClose }, undefined, { layer: isOpen });
  return <Drawer isOpen={isOpen} onClose={onClose} title="Ask Smart Preplan" position="right" maxWidth="xl">
    {isOpen && <AskSmartPreplan />}
  </Drawer>;
}
